import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../services/auth.service";
import { ErrorStateMatcher } from '@angular/material/core';
import { FormBuilder, FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';

/** Error when invalid control is dirty, touched, or submitted. */
export class UserErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  // matcher errors
  public matcher = new UserErrorStateMatcher();

  constructor(
    public authService: AuthService,
    private fb: FormBuilder
  ) { }

  // Create UserAuth Form
  userFormForgot = this.fb.group({
    email: new FormControl('', [Validators.required, Validators.email])
  });

  ngOnInit() {
    this.userFormForgot.controls.email.setValue("");
  }

}
